import { createSlice } from '@reduxjs/toolkit';
import { AssetState } from './assetTypes';
import {
  createAsset,
  fetchAssetById,
  fetchAllAssets,
  updateAsset,
  deleteAsset,
  fetchAssetDetailsByAssetId,
  fetchAssetSummary,
  fetchAssetLog,
  fetchAssetsByEmployeeId,
  fetchAssetRequestBySupervisorHierarchy,
} from './assetActions';

const initialState: AssetState = {
  assets: [],
  assetRequestBySuperwiser: [],
  assetDetails: [],
  assetLogs: [],
  assetSummary: undefined,
  selectedAsset: undefined,
  employeeAssets:[],
  loading: false,
  error: undefined,
};

const assetSlice = createSlice({
  name: 'asset',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create Asset
      .addCase(createAsset.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(createAsset.fulfilled, (state, action) => {
        state.loading = false;
        state.assets.push(action.payload);
      })
      .addCase(createAsset.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch Asset by ID
      .addCase(fetchAssetById.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchAssetById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedAsset = action.payload.data;
      })
      .addCase(fetchAssetById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // Fetch Asset summary
      .addCase(fetchAssetSummary.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchAssetSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.assetSummary = action.payload.data;
      })
      .addCase(fetchAssetSummary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch All Assets
      .addCase(fetchAllAssets.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchAllAssets.fulfilled, (state, action) => {
        state.loading = false;
        state.assets = action.payload.data;
      })
      .addCase(fetchAllAssets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // Fetch  Assets details
      .addCase(fetchAssetDetailsByAssetId.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchAssetDetailsByAssetId.fulfilled, (state, action) => {
        state.loading = false;
        state.assetDetails = action.payload.data;
      })
      .addCase(fetchAssetDetailsByAssetId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // asset log
      .addCase(fetchAssetLog.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchAssetLog.fulfilled, (state, action) => {
        state.loading = false;
        state.assetLogs = action.payload.data;
      })
      .addCase(fetchAssetLog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // Fetch Assets by Supervisor
      .addCase(fetchAssetRequestBySupervisorHierarchy.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchAssetRequestBySupervisorHierarchy.fulfilled, (state, action) => {
        state.loading = false;
        state.assetRequestBySuperwiser = action.payload.data;
      })
      .addCase(fetchAssetRequestBySupervisorHierarchy.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch Assets by Employee ID
      .addCase(fetchAssetsByEmployeeId.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchAssetsByEmployeeId.fulfilled, (state, action) => {
        state.loading = false;
        state.employeeAssets = action.payload.data; 
      })
      .addCase(fetchAssetsByEmployeeId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update Asset
      .addCase(updateAsset.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(updateAsset.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.assets.findIndex(asset => asset.id === action.payload.id);
        if (index !== -1) {
          state.assets[index] = action.payload;
        }
      })
      .addCase(updateAsset.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Delete Asset
      .addCase(deleteAsset.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(deleteAsset.fulfilled, (state, action) => {
        state.loading = false;
        state.assets = state.assets.filter(asset => asset.id !== action.payload.id);
      })
      .addCase(deleteAsset.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default assetSlice.reducer;
